module.exports = __webpack_public_path__ + "static/cateau2-83a9503e370e241adbe40cc07e21e73c.png";